module.exports = __webpack_public_path__ + "img/bg.66681d09.png";